import { useCallback, useEffect, useMemo } from 'react';

import { evHeroClick, evHeroImpression } from 'events/symphony';
import { track } from 'apis/amethyst';
import LandingPageImage from 'components/landing/LandingPageImage';
import LandingPageLink from 'components/landing/LandingPageLink';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/search/searchTopHero.scss';

const SearchTopHero = ({
  searchTerm = '',
  slotDetails,
  shouldLazyLoad = true
}) => {

  const { src, link, alt, mobilesrc, tabletsrc, retina, mobileretina, tabletretina } = slotDetails;
  const { marketplace: { hasBannerAds }, testId } = useMartyContext();

  const linkSearchContext = useMemo(() => ({
    keyword: searchTerm
    // TODO selected filters seem to be mutated in the reducer, so our update logic won't work correctly when we include them
  }), [searchTerm]);

  const handleClick = useCallback(() => {
    track(() => ([
      evHeroClick, { slotName: 'search-header-1', heroCount: 1, slotIndex: 1, slotDetails, linkSearchContext }
    ]));
  }, [linkSearchContext, slotDetails]);

  useEffect(() => {
    track(() => ([
      evHeroImpression, { slotName: 'search-header-1', heroCount: 1, slotIndex: 1, slotDetails, linkSearchContext }
    ]));
  }, [linkSearchContext, searchTerm, slotDetails]);

  if (!hasBannerAds) {
    return null;
  }

  const imgProps = { mobilesrc, src, alt, tabletsrc, retina, mobileretina, tabletretina, shouldLazyLoad };
  return (
    <LandingPageLink
      url={link}
      className={css.innerWrapper}
      onClick={handleClick}
      data-test-id={testId('searchTopHero')}
    >
      <LandingPageImage {...imgProps} />
    </LandingPageLink>
  );
};

export default SearchTopHero;
